import { render } from "./DeleteItemComponent.vue?vue&type=template&id=d2225536&scoped=true"
import script from "./DeleteItemComponent.vue?vue&type=script&lang=js"
export * from "./DeleteItemComponent.vue?vue&type=script&lang=js"

import "./DeleteItemComponent.vue?vue&type=style&index=0&id=d2225536&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2225536"]])

export default __exports__